<template>
    <EmptyBadge v-if="rows.length < 1"></EmptyBadge>

    <div
        v-else
        :class="[checkSizable(sizable), checkHoverAvailable(isHoverAvailable)]"
        class="list-items c1"
    >
        <div
            v-for="(row, index) in rows"
            :key="index"
            class="item"
        >
            <span
                :class="{ 'border-hr': index < rows.length - 1 }"
            >
                <code>{{ row.name }}</code>
            </span>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import EmptyBadge from '../subcomponents/EmptyBadge';

export default {
    components: {
        EmptyBadge,
    },
    props: {
        rows: Array,
        sizable: Boolean,
        isHoverAvailable: Boolean,
    },
    methods: {
        log(data) {
            return typeof data;
        },
        checkSizable: function (value) {
            return value === true ? 'sizable' : '';
        },
        checkHoverAvailable: function (value) {
            return value === true ? 'hoverable' : '';
        },
    },
};
</script>
